import { render, staticRenderFns } from "./afasCompanyCreate.vue?vue&type=template&id=46a11649&"
import script from "./afasCompanyCreate.vue?vue&type=script&lang=js&"
export * from "./afasCompanyCreate.vue?vue&type=script&lang=js&"
import style0 from "./afasCompanyCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports